import {OrganisationDetails} from "./OrganisationDetails";
import {OrganisationStatus} from "../enums/organisation-status.enum";
import {Industry} from "../../../industry";
import {User} from "../../../user";
import {MetaData} from "@qid/core";


export class Organisation extends MetaData {
  _id: string;
  name: string;
  createByUser: User | any | string;
  industry: Industry;
  lastModified: string;
  organisationDetails: OrganisationDetails = new OrganisationDetails();
  displayPictureUrl: string;
  phoneNumber: string
  email: string
  publicKey: string;
  status: OrganisationStatus;
  serial: string;

  constructor() {
    super();
  }
}


